var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRipple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00AAE4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M21.96 18.205c-.69-.408-1.467-.526-2.237-.554-.646-.023-1.61-.447-1.61-1.65 0-.898.71-1.62 1.61-1.652.77-.027 1.548-.146 2.238-.554 1.713-1.014 2.47-3.141 1.793-5.046-.677-1.905-2.591-3.037-4.54-2.685-1.949.352-3.37 2.086-3.37 4.114 0 .809.282 1.554.64 2.244.302.581.454 1.66-.58 2.271-.77.455-1.73.167-2.21-.619-.404-.664-.893-1.286-1.578-1.691-1.713-1.014-3.89-.62-5.162.932a4.255 4.255 0 0 0 0 5.37c1.272 1.553 3.449 1.946 5.162.932.685-.404 1.174-1.026 1.579-1.69.332-.545 1.162-1.24 2.209-.62.768.455 1.006 1.45.58 2.271-.359.69-.64 1.435-.64 2.245 0 2.027 1.421 3.761 3.37 4.113 1.949.352 3.863-.78 4.54-2.685.676-1.905-.08-4.032-1.793-5.046z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple);
export default __webpack_public_path__ + "static/media/ripple.955b24f95f14f28f01e29d422ac6b682.svg";
export { ForwardRef as ReactComponent };